import { Component, Input, Output, EventEmitter,ViewChild, AfterViewInit } from '@angular/core';
import { FileUploadService } from './../file-upload.service';
import { FacebookShareComponent } from './../facebook-share/facebook-share.component';
import { ReviewComponent } from '../review/review.component';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
@Component({
    selector: 'app-download-button',
    standalone:true,
    imports: [FacebookShareComponent, ReviewComponent,MatIconModule],
    templateUrl: './download-button.component.html',
    styleUrls: ['./download-button.component.css']
})
export class DownloadButtonComponent {
  @Input() blob!: Blob;
  @Input() fileName: string = 'converted_file.png'; // Default file name
  @Input() splitFrom: string = ''; 
  @Input() splitTo: string = ''; 
  @Input() fileType: string = ''; 
  @Input() selectedDownloadHeader: string = '';
  @Input() selectedDownloadButton: string = '';
  @Input() selectedIconIdentifireRequest: string = '';
  @Output() dataEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() iconSelected = new EventEmitter<string>();
  @Input() isDownload:boolean=true;
  

  //@ViewChild(AppComponent) appComponent!: AppComponent;
  constructor(private fileUploadService: FileUploadService,public dialog: MatDialog) {}
  
  onIconClick(iconidentifire: string) {
    this.iconSelected.emit(iconidentifire);
  }
  downloadFile(): void {
    this.fileUploadService.currentDownloadFileType.subscribe(fileType => this.fileType = fileType);
    let fName = '';
    if (this.fileType=='pdf') {
      fName = 'document.pdf';
    } else if (this.fileType=='png') {
      fName = 'image.png';
    } else if (this.fileType=='word') {
      fName = 'document.docx';
    }
    else if (this.fileType=='excel') {
      fName = 'document.xlsx';
    }
    else if (this.fileType=='zip') {
      if(this.splitFrom!='' && this.splitTo!='')
      {
        fName = 'document.pdf';
      }
      else
      {
      fName = 'document.zip';
      }
    }
    const url = window.URL.createObjectURL(this.blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fName; // Change the file name and extension as needed
    link.click();
    window.URL.revokeObjectURL(url); // Free up memory

    //open popup dialog box
    this.dialog.open(ReviewComponent, {
      width: '400px', // Adjust size as needed
      disableClose: false, // Allow clicking outside to close
    });
  }
 
  getIdentifire() {
   
     this.dataEmitter.emit(this.selectedIconIdentifireRequest);
    this.isDownload=true;
  }
  openReviewPopup() {
    this.dialog.open(ReviewComponent, {
      width: '400px', // Adjust size as needed
      disableClose: false, // Allow clicking outside to close
    });
  }
  
}
